// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-row {
  width: 100%;
  height: 28px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-left: 4px;
}
.entity-row__text-block {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.entity-row__name {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10px;
}
.entity-row__entity {
  margin-right: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.entity-row__icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
}
.entity-row__workbook-relations {
  margin-left: 8px;
  padding-left: 4px;
  border-left: 1px solid var(--g-color-line-generic);
}
.entity-row__right-block {
  flex-shrink: 0;
  width: 50%;
  display: grid;
  grid-template-columns: 4fr 3fr auto;
}
.entity-row__delegation-status {
  display: flex;
  align-items: center;
  gap: 6px;
}
.entity-row__delegation-status-icon {
  flex-shrink: 0;
  color: var(--g-color-text-secondary);
}
.entity-row__notice {
  max-width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntityRow/EntityRow.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AAFJ;AAII;ECPA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDUxB,gBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAGI;ECqJA,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;EAtKA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDkBxB,iBAAA;AAIR;AADI;EACI,kBAAA;EAEA,gBAAA;EACA,aAAA;EACA,mBAAA;AAER;AACI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,gBAAA;EACA,iBAAA;EACA,kDAAA;AAAR;AAGI;EACI,cAAA;EACA,UAAA;EACA,aAAA;EACA,mCAAA;AADR;AAII;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAFR;AAKI;EACI,cAAA;EACA,oCAAA;AAHR;AAMI;EACI,gBAAA;AAJR","sourcesContent":[".entity-row {\n  width: 100%;\n  height: 28px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-left: 4px;\n}\n.entity-row__text-block {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.entity-row__name {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 10px;\n}\n.entity-row__entity {\n  margin-right: 10px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.entity-row__icon {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n}\n.entity-row__workbook-relations {\n  margin-left: 8px;\n  padding-left: 4px;\n  border-left: 1px solid var(--g-color-line-generic);\n}\n.entity-row__right-block {\n  flex-shrink: 0;\n  width: 50%;\n  display: grid;\n  grid-template-columns: 4fr 3fr auto;\n}\n.entity-row__delegation-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.entity-row__delegation-status-icon {\n  flex-shrink: 0;\n  color: var(--g-color-text-secondary);\n}\n.entity-row__notice {\n  max-width: 250px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
